import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectRatio1To320(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconMediaObjectRatio1To320"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5.5 4.5v11a1 1 0 1 1-2 0v-11a1 1 0 0 1 2 0M2 4.5a2.5 2.5 0 0 1 5 0v11a2.5 2.5 0 0 1-5 0zm7.04-.75A.75.75 0 0 1 9.79 3h8.439a.75.75 0 0 1 0 1.5H9.79a.75.75 0 0 1-.75-.75m0 6A.75.75 0 0 1 9.79 9h8.439a.75.75 0 0 1 0 1.5H9.79a.75.75 0 0 1-.75-.75M9.79 6a.75.75 0 1 0 0 1.5h5.642a.75.75 0 0 0 0-1.5zm-.75 6.75a.75.75 0 0 1 .75-.75h5.642a.75.75 0 0 1 0 1.5H9.791a.75.75 0 0 1-.75-.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObjectRatio1To320);
